export default "__VITE_ASSET__DybPTHRs__"